<!-- 选择题 -->
<template>
  <div
    class="mobile-question-wrap"
    :class="{
      ['question_' + questionInfo.id]: true,
      'big-question-detail-wrap': !questionInfo.pid,
    }"
  >
    <div class="choice-question-wrap">
      <!-- 完型填空不展示题干 -->
      <template
        v-if="
          questionInfo.big_question_type !==
          QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL
        "
      >
        <question-type
          :class="{ 'is-fixed': questionTypeFiexd }"
          :info="{
            question_type: questionInfo.question_type,
            score: questionInfo.score,
          }"
        />
        <!-- 题干 -->
        <div class="question-content-wrap">
          <span> {{ questionIndexObj[questionInfo.id] + 1 }}.</span>
          <div
            v-if="questionInfo.content"
            class="question-content"
            v-html="questionInfo.content"
          />
        </div>
      </template>
      <!-- 选项列表 -->
      <div
        v-if="
          questionInfo?.option?.length &&
          [
            QUESTION_TYPE_NAME.SINGLE_CHOICE,
            QUESTION_TYPE_NAME.MULTIPLE_CHOICE,
            QUESTION_TYPE_NAME.JUDGE,
          ].includes(questionInfo.question_type)
        "
        class="choice-answers"
      >
        <custom-option
          :type="
            questionInfo.question_type === QUESTION_TYPE_NAME.MULTIPLE_CHOICE
              ? 'checkbox'
              : 'radio'
          "
          :options="handleOptions"
          v-model="questionInfo.userAnswer"
          @select-change="handleSelectChange"
          :disabled="!canSubmit"
        />
      </div>
      <!-- 解析 -->
      <el-collapse v-if="isCorrected" v-model="activeNames">
        <el-collapse-item :name="0" :disabled="true">
          <template slot="title">文字解析</template>
          <div
            v-if="questionInfo.analysis"
            v-html="questionInfo.analysis"
          ></div>
          <div v-else>暂无解析</div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import QuestionType from "@saas/pages/src/homework/components/QuestionType.vue";
import CustomOption from "@saas/pages/src/homework/components/CustomOption.vue";
import {
  QUESTION_TYPE_NAME,
  WORK_STATUS,
} from "@saas/components/src/constants/question";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  props: {
    questionInfo: {
      type: Object,
      default: () => ({}),
    },
    questionTypeFiexd: {
      type: Boolean,
      default: true,
    },
    swiperIndex: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      QUESTION_TYPE_NAME,
      activeNames: [0],
    };
  },
  mounted() {
    EventBus.$off(`handleSlideChangeEnd${this.swiperIndex}`);
    EventBus.$on(`handleSlideChangeEnd${this.swiperIndex}`, () => {
      this.setActiveIndex(this.showQuestionIndexObj[this.questionInfo.id]);
    });
  },
  methods: {
    ...mapMutations("defaultHomework", ["setActiveIndex"]),
    ...mapActions("defaultHomework", [
      "apiMarkerQuestion",
      "apiAnswerQuestion",
    ]),
    handleMarkQuestion(questionInfo) {
      let { id, subIndex, pidIndex } = questionInfo;
      let params = {
        work_id: this.workId,
        question_id: id,
        is_markers: this.questionInfo?.is_markers === 1 ? 2 : 1,
        subIndex,
        pidIndex,
      };
      this.apiMarkerQuestion(params);
    },
    handleSelectChange(val) {
      let { pid, id, userAnswer, question_type } = this.questionInfo;
      let params = {
        work_id: this.workId,
        question_pid: pid,
        question_id: id,
        answer: String(userAnswer),
        question_type,
      };
      this.apiAnswerQuestion(params);
    },
  },
  computed: {
    ...mapGetters("defaultHomework", [
      "showQuestionIndexObj",
      "canSubmit",
      "questionIndexObj",
    ]),
    ...mapState("defaultHomework", [
      "workId",
      "questionList",
      "workInfo",
      "isCorrected",
      "showErrorAnalysis",
    ]),
    handleOptions() {
      return this.questionInfo.option.map((option) => {
        return {
          ...option,
          value: String(option.id),
          label: option.answer,
        };
      });
    },
    judgeWrong() {
      // 已批改且非复合题且未答对
      return (
        this.isCorrected &&
        !this.questionInfo?.pid &&
        !this.questionList?.[this.questionIndexObj?.[this.questionInfo?.id]]
          ?.is_right
      );
    },
  },
  components: {
    CustomOption,
    QuestionType,
  },
};
</script>

<style lang="scss" scoped>
.mobile-question-wrap {
  overflow-y: auto;
  height: 100%;
  overflow-x: hidden;
  .choice-question-wrap {
    .mobile-question-type-wrap.is-fixed {
      position: absolute;
      top: 0.32rem;
      left: 0.32rem;
    }
  }
  .question-content-wrap {
    display: flex;
    font-weight: 500;
    font-size: 0.43rem;
    color: #1d2129;
    line-height: 0.69rem;
    margin-bottom: 0.43rem;
    .question-content {
      font-weight: 500;
      font-size: 0.43rem;
      color: #1d2129;
      line-height: 0.69rem;
      line-break: anywhere;
    }
  }

  // 解析
  ::v-deep .el-collapse {
    margin-top: 0.11rem;
    border: none;
    .el-collapse-item__header {
      height: 40px;
      // border: 1px solid #f2f3f5;
      border: none;
      background: #ffffff;
      border-radius: 0.21rem;
      padding: 0.27rem 0.24rem 0.27rem 0.43rem;
      font-weight: 400;
      font-size: 0.37rem;
      color: #1d2129;
      position: relative;
      line-height: 0.53rem;
      &::before {
        display: block;
        content: "";
        position: absolute;
        width: 0.05rem;
        height: 0.32rem;
        background: #00c89d;
        border-radius: 0.03rem;
        background: $homework-right-color;
        left: 0.24rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .el-collapse-item {
      border-radius: 0.21rem;
      // border: none;
      border: 1px solid #f2f3f5;
    }
    .el-collapse-item__content {
      font-weight: 500;
      font-size: 0.43rem;
      color: #1d2129;
      line-height: 0.69rem;
      padding: 0 0.32rem 0.32rem;
      border-radius: 0.21rem;
      line-break: anywhere;
    }
    .el-collapse-item__arrow {
      display: none;
    }
    .el-collapse-item__wrap {
      border-bottom: 0;
      border-radius: 0.21rem;
    }
  }
}
</style>
